<template>
  <div class="container">
    <v-tabs
      v-model="mainTab"
      fixed-tabs
      background-color="blue accent-1 gray--text"
      class="elevation-1"
    >
      <v-tab>
        Nueva Devolución
      </v-tab>
      <v-tab>
        Lista de despachos
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="mainTab">
      <v-tab-item class="elevation-1">
        <v-row class="mx-2 my-2">
            <v-col>
                <v-btn text>Fecha Devolución</v-btn>
                <date-picker placeholder="Fecha" class="dtpicker" label="Fecha Devolución" v-model="devolucion.return_date" format="DD-MM-YYYY" valueType="YYYY-MM-DD"></date-picker>
            </v-col>
            <v-col>
                <v-select
                    v-model="devolucion.shift"
                    :items="shifts"
                    item-text="name"
                    item-value="id"
                    label="Turno"
                    placeholder="Turno"
                ></v-select>
            </v-col>
            <v-col>
                <v-select
                    v-model="devolucion.provider"
                    :items="providers"
                    item-text="name"
                    item-value="id"
                    label="Cliente"
                    placeholder="Cliente"
                ></v-select>
            </v-col>
            <v-col>
                <v-select
                    v-model="devolucion.facility"
                    :items="facilities"
                    item-text="name"
                    item-value="id"
                    label="Planta de Origen"
                    placeholder="Planta de Origen"
                ></v-select>
            </v-col>
            <v-col>
                <v-btn
                    color = "primary"
                    @click.once="saveReturn"
                    :key="btnSaveKey"
                >Grabar</v-btn>
            </v-col>
        </v-row>
        <v-row class="mx-2 my-2">
            <v-col cols="12">
                <h4>Lista de bins despachados y que se pueden devolver</h4>
            </v-col>
            <v-col cols="12">
                <v-data-table 
                    v-model="returnBins"
                    :headers="binsListHeaders"
                    :items="binsListBody"
                    class="elevation-1"
                    show-select
                    dense
                    no-data-text="No hay bins"
                >
                    <template v-slot:[`item.actions`]="{item}">
                        <v-icon
                        medium
                        @click="deleteBin(item)"
                        >
                        mdi-delete
                        </v-icon>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
      </v-tab-item>
      <v-tab-item class="elevation-1">
        <v-row class="mx-1">
          <v-col cols="4">
            <v-btn @click="download" color="primary">Excel</v-btn>
          </v-col>
          <v-col cols="4">
            <v-text-field
                v-model="returnSearch"
                append-icon="mdi-magnify"
                label="Escriba para filtrar despachos"
                single-line
                hide-details
            ></v-text-field>
          </v-col>
        </v-row>
        <v-data-table 
          :headers="returnsListHeaders"
          :items="returnsListBody"
          class="elevation-1"
          no-data-text="No hay despachos"
          :search="returnSearch"
        >
          <template v-slot:[`item.shipping_date`]="{item}">
            {{ formatDate(item.shipping_date )}}
          </template>
          <template v-slot:[`item.actions`]="{item}">
            <v-tooltip left>
              <template v-slot:activator="{ on }">
                <v-icon
                  medium
                  class="mr-2"
                  @click="editShipping(item)"
                  v-on="on"
                >
                  mdi-pencil
                </v-icon>
              </template>
              <span>Editar despacho</span>
            </v-tooltip>
            <v-tooltip left>
              <template v-slot:activator="{ on }">
                <v-icon
                  medium
                  class="mr-2"
                  @click="deleteShipping(item)"
                  v-on="on"
                >
                  mdi-delete
                </v-icon>
              </template>
              <span>Borrar despacho</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-tab-item>
    </v-tabs-items>
    
    <!-- Modal Copy -->
    <v-dialog
      v-model="dialogCopy"
      transition="fab-transition"
      width="600px"
    >
      <v-card>
        <v-card-title class="blue darken-2">
          Copiar lista de bins
        </v-card-title>
        <v-container>
          <v-textarea
            auto-grow
            filled
            rows="20"
            :value="copyBins"></v-textarea>
        </v-container>
        <v-card-actions>
          <v-btn
            @click="dialogCopy = false"
          >Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- / Modal -->

    <v-snackbar
      v-model="snackbar"
      :timeout="5000"
      :color="color"
    >
      {{ validation_message }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
  import {mapState, mapMutations} from 'vuex'
  //datepicker vue2
  import DatePicker from 'vue2-datepicker';
  import 'vue2-datepicker/index.css';
  import 'vue2-datepicker/locale/es';

  export default {
    data: () => ({
      snackbar: false,
      sbcolor: 'green',
      validation_message: '',
      url_excel: '',
      returnSearch: null,
      copyBins: '',
      bins1000: [],
      bins800: [],
      dialog: false,
      dialogCopy: false,
      success: null,
      mainTab: null,
      tab: null,
      isLoading: false,
      bin: null,
      binSearch: null,
      code: 0,
      shift: null,
      shifts: [],
      bins: [],
      state: null,
      states: [],
      company: null,
      companies: [],
      otherOwner: null,
      otherOwners: [],
      providers: [],
      facilities: [],
      facilitySearch: null,
      providerSearch: null,
      color: null,
      colors: [],
      size: null,
      binSize: 1,
      binColor: 1,
      sizes: [],
      quantity: '',
      patents: [],
      patentSearch: null,
      returnIndex: -1,
      returnBins: [],
      btnSaveKey: 1,
      devolucion: {
        id: 0,
        facility: {
          id: 0,
          code: ''
        },
        shift: {
          id: 0,
          name: ''
        },
        provider: {
          id: 0,
          name: ''
        },
        shipping: [],
        return_date: new Date().toISOString().substr(0, 10),
      },
      returnsListHeaders: [
        {
          text: 'Fecha',
          align: 'center',
          sortable: true,
          value: 'shipping_date',
          class: "salmon black--text elevation-1 elevation-3"
        },
        {
          text: 'Turno',
          align: 'center',
          sortable: true,
          value: 'shift.name',
          class: "salmon black--text elevation-1 elevation-3"
        },
        {
          text: 'Planta Destino',
          align: 'center',
          sortable: true,
          value: 'facility.name',
          class: "salmon black--text elevation-1 elevation-3"
        },
        {
          text: 'Patente',
          align: 'center',
          sortable: true,
          value: 'patent',
          class: "salmon black--text elevation-1 elevation-3"
        },
        {
          text: 'Guia Despacho',
          align: 'center',
          sortable: true,
          value: 'waybill',
          class: "salmon black--text elevation-1 elevation-3"
        },
        {
          text: 'Certificado',
          align: 'center',
          sortable: true,
          value: 'certificate',
          class: "salmon black--text elevation-1 elevation-3"
        },
        {
          text: 'Bins',
          align: 'center',
          sortable: true,
          value: 'bins',
          class: "salmon black--text elevation-1 elevation-3"
        },
        {
          text: 'Acciones',
          align: 'center',
          sortable: false,
          value: 'actions',
          class: "salmon black--text elevation-1 elevation-3"
        },
      ],
      returnsListBody: [],
      binsListHeaders: [
        {
          text: 'Codigo',
          align: 'center',
          sortable: true,
          value: 'bin.code',
          class: "salmon black--text elevation-1 elevation-3"
        },
        {
          text: 'Estado',
          align: 'center',
          sortable: true,
          value: 'state.name',
          class: "salmon black--text elevation-1 elevation-3"
        },
        {
          text: 'Acciones',
          align: 'center',
          sortable: false,
          value: 'actions',
          class: "salmon black--text elevation-1 elevation-3"
        },
      ],
      binsListBody: [],
      othersListHeaders: [
        {
          text: '#',
          align: 'center',
          sortable: true,
          value: 'quantity',
          class: "salmon black--text elevation-1 elevation-3"
        },
        {
          text: 'Propietario',
          align: 'center',
          sortable: true,
          value: 'company.name',
          class: "salmon black--text elevation-1 elevation-3"
        },
        {
          text: 'Color',
          align: 'center',
          sortable: true,
          value: 'color.name',
          class: "salmon black--text elevation-1 elevation-3"
        },
        {
          text: 'Tamaño',
          align: 'center',
          sortable: true,
          value: 'size.name',
          class: "salmon black--text elevation-1 elevation-3"
        },
        {
          text: 'Acciones',
          align: 'center',
          sortable: false,
          value: 'actions',
          class: "salmon black--text elevation-1 elevation-3"
        },
      ],
      othersListBody: [],
    }),
    mounted() {
      this.loadFacilities();
      this.loadStates();
      this.loadCompanies();
      this.loadShifts();
      this.loadShippings();
    },
    methods:{
      async loadCompanies(){
        let url = `${this.base_url}companies`;
        await this.axios.get(url, this.headers).then((response)=>{
            this.providers = response.data.data;
        }).catch((error)=>{
            console.log(error);
        });
      },
      async loadFacilities(){
        let url = `${this.base_url}facilities`;
        await this.axios.get(url, this.headers).then((response)=>{
            this.facilities = response.data.data;
        }).catch((error)=>{
            console.log(error);
        });
      },
      async loadStates(){
        let url = `${this.base_url}states`;
        await this.axios.get(url, this.headers).then((response)=>{
            this.states = response.data.data;
            this.state = this.states[0];
        }).catch((error)=>{
            console.log(error);
        });
      },
      async loadShifts(){
        let url = `${this.base_url}shifts`;
        await this.axios.get(url, this.headers).then((response)=>{
            this.shifts = response.data.data;
        }).catch((error)=>{
            console.log(error);
        });
      },
      async loadShippings(){
        let url = `${this.base_url}shippings/report/last/100`;
        await this.axios.get(url, this.headers).then((response)=>{
            this.returnsListBody = response.data.data.report_data;
            this.url_excel = this.storage_url + response.data.data.url_excel;
        }).catch((error)=>{
            console.log(error);
        });
      },
      async saveReturn(){
        // validation
        this.success = null;
        this.errors = [];

        if(!this.devolucion.provider.id){
            this.errors.push("Debe seleccionar un proveedor");
        }
        if(!this.devolucion.facility.id){
            this.errors.push("Debe seleccionar una planta");
        }
        if(!this.devolucion.shift.id){
            this.errors.push("Debe seleccionar una turno");
        }
        if(this.returnBins.length == 0){
            this.errors.push("Debe seleccionar bins");
        }
        if(this.errors.length > 0){
          this.validation_message = this.errors.join();
          this.showSnackBar(false);
          return;
        }
        console.log(this.devolucion);
        let url = `${this.base_url}returns`;
        let sendData = {
          'devolucion':{
            'main': {
              'shippings_id': this.devolucion.shipping.id,
              'shifts_id': this.devolucion.shift.id,
              'provider_id': this.devolucion.shipping.provider.id,
              'facility_id': this.devolucion.shipping.facility.id,
              'return_date': this.devolucion.return_date,
            },
            'details': [],
          }
        };
        this.returnBins.forEach(item => {
          let data = {
            'returns_id': 0,
            'bins_id': item.bin.id,
            'states_id': item.state.id,
          }
          sendData.devolucion.details.push(data);
        });
        //console.log(sendData);
        let response = null;
        if(this.devolucion.id > 0){
          url = url + "/" + this.devolucion.id;
          try{
            response = await this.axios.put(url, JSON.stringify(sendData), this.headers);
            this.validation_message = "Grabado exitosamente!";
            this.cleanForm();
            this.showSnackBar(false);
          }catch(error){
            response = error.response;
            let msg = response.data.data;
            this.validation_message = response.status + ': ' + response.data.message + '. '+ msg;
            this.showSnackBar(true);
            this.btnSaveKey++;
          }
        }else{
          try{
            response = await this.axios.post(url, JSON.stringify(sendData), this.headers);
            this.cleanForm();
            this.showSnackBar(false);
          }catch(error){
            response = error.response;
            let msg = response.data.data;
            this.validation_message = response.status + ': ' + response.data.message + '. '+ msg;
            this.showSnackBar(true);
            this.btnSaveKey++;
          }
        }
      },
      cleanForm(){
        this.binsListBody = [];
        this.devolucion = {
            id: 0,
            facility: {
                id: 0,
                code: ''
            },
            shift: {
                id: 0,
                name: ''
            },
            provider: {
                id: 0,
                name: ''
            },
            shipping: [],
            return_date: new Date().toISOString().substr(0, 10),
        };
      },
      editShipping(item) {
        this.mainTab = "0";
        this.devolucion.return_date = new Date().toISOString().substr(0, 10);
        this.devolucion.shipping = item;
        this.devolucion.shift = item.shift;
        this.devolucion.provider = item.provider;
        this.devolucion.facility = item.facility;
        this.binsListBody = item.plp_bins;
      },
      download(){
        window.location.href = this.url_excel;
      },
      showSnackBar(error){
        if(error){
          this.color = 'red';
        }else{
          this.color = 'green';
          this.validation_message = "Ejecutado exitosamente!";
        }
        this.snackbar = true;
      },
      formatDate (date) {
        if (!date) return null
        const [year, month, day] = date.split('-')
        return `${day}-${month}-${year}`
      },
      ...mapMutations(['actualizarBaseUrl']),
    },
    computed:{
      plpBins: function(){
        return this.binsListBody.length;
      },
      otherBins: function(){
        let quantity = 0;
        this.othersListBody.forEach(bin => {
          quantity += parseInt(bin.quantity);
        });
        return quantity;
      },
      ...mapState(['authenticated', 'loading', 'base_url', 'storage_url', 'headers'])
    },
    components:{
      DatePicker
    }
  }
</script>